import { useEffect, useState } from 'react';
import { AdminSidebar } from '../../components/Sidebar';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';

export default function AdminStats() {
  const { hasFeature } = useAuth();
  const [data, setData] = useState(null);
  const [knowledgeMap, setKnowledgeMap] = useState(null);

  useEffect(() => {
    if (!hasFeature('stats')) return;
    api.get('/admin/stats').then(r => setData(r.data));
    api.get('/admin/stats/knowledge-map').then(r => setKnowledgeMap(r.data.categories)).catch(() => {});
  }, []);

  const maxTotal = knowledgeMap ? Math.max(...knowledgeMap.map(c => c.total), 1) : 1;

  if (!hasFeature('stats')) {
    return (
      <div style={{ display: 'flex' }}>
        <AdminSidebar />
        <main className="main-content">
          <h1 style={{ fontSize: 28, marginBottom: 24 }}>Statistiken</h1>
          <UpgradePrompt feature="Statistiken" />
        </main>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex' }}>
      <AdminSidebar />
      <main className="main-content">
        <h1 style={{ fontSize: 28, marginBottom: 24 }}>Statistiken</h1>
        {!data ? <div className="spinner-wrap"><div className="spinner"/></div> : (
          <>
            <div className="grid-3 mb-6">
              {[
                { label: 'Gesamt Quizze', value: data.quizStats?.total_quizzes },
                { label: 'Abgeschlossen', value: data.quizStats?.finished },
                { label: 'Aktiv', value: data.quizStats?.active },
              ].map(s => (
                <div key={s.label} className="stat-card">
                  <div className="stat-value">{s.value || 0}</div>
                  <div className="stat-label">{s.label}</div>
                </div>
              ))}
            </div>

            {/* Knowledge map */}
            {knowledgeMap && knowledgeMap.length > 0 && (
              <div className="card" style={{ marginBottom: 24 }}>
                <h3 style={{ fontSize: 14, color: 'var(--text3)', marginBottom: 4 }}>WISSENSKARTE</h3>
                <p style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 20 }}>
                  Richtige Antworten pro Kategorie (alle Sessions)
                </p>
                {knowledgeMap.map((c, i) => {
                  const pct = c.total > 0 ? Math.round((c.correct / c.total) * 100) : 0;
                  const barColor = pct >= 70 ? '#5B8A75' : pct >= 40 ? '#C9A84C' : '#E05C4B';
                  return (
                    <div key={i} style={{ marginBottom: 16 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                        <span style={{ fontSize: 14, fontWeight: 500, color: 'var(--text)' }}>{c.category}</span>
                        <span style={{ fontSize: 13, fontWeight: 700, color: barColor }}>{pct}%</span>
                      </div>
                      <div style={{ height: 10, background: 'var(--surface)', borderRadius: 5, overflow: 'hidden' }}>
                        <div style={{
                          width: `${pct}%`, height: '100%',
                          background: barColor, borderRadius: 5,
                          transition: 'width 0.6s ease',
                        }} />
                      </div>
                      <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 3 }}>
                        {c.correct} / {c.total} Antworten richtig
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            <div className="card">
              <h3 style={{ fontSize: 14, color: 'var(--text3)', marginBottom: 16 }}>TOP TEILNEHMER</h3>
              {(data.topParticipants || []).map((p, i) => (
                <div key={i} className="leaderboard-item">
                  <div className={`rank-number ${i<3?`rank-${i+1}`:''}`}>{i+1}</div>
                  <div style={{ flex: 1 }}>
                    <strong>{p.first_name} {p.last_name}</strong>{' '}
                    <span style={{ color: 'var(--text3)', fontSize: 13 }}>({p.games} Spiele)</span>
                  </div>
                  <div style={{ fontWeight: 700, color: 'var(--primary)' }}>{p.total} Pkt.</div>
                </div>
              ))}
            </div>
          </>
        )}
      </main>
    </div>
  );
}

function UpgradePrompt({ feature }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '64px 24px', textAlign: 'center', background: '#fff',
      border: '1px solid #e5e7eb', borderRadius: 12, maxWidth: 480, margin: '0 auto',
    }}>
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: 16 }}>
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
      <div style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e', marginBottom: 8 }}>
        {feature} nicht verfugbar
      </div>
      <div style={{ fontSize: 14, color: '#6b7280', marginBottom: 24 }}>
        Diese Funktion ist im Free-Plan nicht enthalten. Upgraden Sie Ihren Plan, um Zugriff zu erhalten.
      </div>
      <a
        href="https://ilmify.ch/#pricing"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          background: '#2563eb', color: '#fff', padding: '10px 24px',
          borderRadius: 8, fontSize: 14, fontWeight: 600, textDecoration: 'none',
        }}
      >
        Plan upgraden
      </a>
    </div>
  );
}
